
<div class="row">
  <div class="col-lg-12 grid-margin">
    <div class="card">
      <div class="card-body upper-header" *ngIf = "!showPay">

        <div class="filter-wrapper field_space" *ngIf = "form">
          <form   [formGroup]="form" novalidate (ngSubmit)="saveData()">
                <div class="form-group col-4-div">
                    <label>Mobile Number <span class="text-danger" >*</span></label>
                    <input class="form-control border-primary"
                        formControlName="mobile_no">
                    <div *ngIf="form.get('mobile_no').touched && form.get('mobile_no').invalid" class="text-danger inaild_no">
        <span *ngIf="form.get('mobile_no').errors.required">
            Mobile Number is required.
        </span>

        <span *ngIf="form.get('mobile_no').errors.pattern">
            Please enter a valid mobile number.
        </span>

        <span *ngIf="form.get('mobile_no').errors.minlength || form.get('mobile_no').errors.maxlength">
            Mobile Number must be 10 digits.
        </span>
    </div>
                </div>

                <div class="form-group col-4-div">
                    <label>Atithiniwas <span class="text-danger" >*</span></label>
                    <select class="form-control border-primary" formControlName="dharmshala_id">
                        <option value="">Select</option>
                        <option *ngFor="let item of allDharmshala"
                        [value]="item.id">{{item.name}}</option>
                    </select>
                    <div *ngIf="form.get('dharmshala_id').touched && form.get('dharmshala_id').invalid" class="text-danger inaild_no">
        Atithiniwas is required.
    </div>
                </div>

                <div class="form-group col-4-div">
                  <label>Check In Date <span class="text-danger" >*</span></label>
                  <input class="form-control border-primary" [min] = "minDate" [max] = "to_date" [owlDateTime]="dt" placeholder="Date" name="check_in_date" formControlName="request_for_date">
                  <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
                  <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                  <div *ngIf="form.get('request_for_date').touched && form.get('request_for_date').invalid" class="text-danger inaild_no">
        Check In Date is required.
    </div>
                </div>
                <div class="form-group col-4-div">
                    <label>Check Out Date <span class="text-danger" >*</span></label>
                    <input class="form-control border-primary" [min] = "from_date" [max] = "maxDate" [owlDateTime]="dt1" placeholder="Date" name="check_out_date" formControlName="checkout_date">
                    <span [owlDateTimeTrigger]="dt1" class="date-ico"><i class="fa fa-calendar"></i></span>
                    <owl-date-time #dt1 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                    <div *ngIf="form.get('checkout_date').touched && form.get('checkout_date').invalid" class="text-danger inaild_no">
        Check Out Date is required.
    </div>
                </div>

                <div class="form-group col-4-div" *ngIf="availableRooms && availableRooms.length">
                    <label>Available Room Type <span class="text-danger" >*</span></label>
                    <select
                        class="form-control border-primary"
                        formControlName="room_type_id">
                        <option value="">Select</option>
                        <option
                          *ngFor="let item of availableRooms"
                          [value]="item.room_type_id"
                          [disabled]="!item.is_booking_available">
                          {{ item.room_type_title }} - {{ item.charges }}
                          {{ !item.is_booking_available ? ' (Not Available)' : '' }}
                        </option>
                        </select>
                        <div *ngIf="form.get('room_type_id').touched && form.get('room_type_id').invalid" class="text-danger inaild_no">
        Please select a Room Type.
    </div>
                </div>


                <div class="form-group col-4-div">
                    <label>Email <span class="text-danger" >*</span></label>
                    <input formControlName="email_id" class="form-control border-primary" type="email" placeholder="" />
                    <div *ngIf="form.get('email_id')?.touched && form.get('email_id')?.invalid" class="text-danger inaild_no">
  <span *ngIf="form.get('email_id')?.errors?.required">
    Email is required.
  </span>
  <span *ngIf="form.get('email_id')?.errors?.email">
    Please enter a valid email address.
  </span>
</div>
                  </div>

                  <div class="form-group col-4-div">
                    <label>Country <span class="text-danger" >*</span></label>
                    <select formControlName="country_id" class="form-control border-primary" (change)="onCountryChange(form.value.country_id)">
                      <option value="">Select Country</option>
                      <option *ngFor="let data of countriesData" [ngValue]="data.id">{{ data.name }}</option>
                    </select>  
                    <div *ngIf="form.get('country_id')?.touched && form.get('country_id')?.invalid" class="text-danger inaild_no">
  Country is required.
</div>
                  </div>

                  <div class="form-group col-4-div">
                    <label>State <span class="text-danger" *ngIf="isIndiaSelected()">*</span></label>
                    <select formControlName="state_id" class="form-control border-primary">
                      <option value="">Select State</option>
                      <option *ngFor="let data of allStates" [ngValue]="data.id">{{ data.name }}</option>
                    </select>
                    <div *ngIf="form.get('state_id')?.touched && form.get('state_id')?.invalid" class="text-danger inaild_no">
  <span *ngIf="form.get('state_id')?.errors?.required">
    State is required.
  </span>
</div>
                  </div>
              
                  <div class="form-group col-4-div">
                    <label>City Name <span class="text-danger" >*</span></label>
                    <input formControlName="city" class="form-control border-primary" type="text" placeholder=" " />
                    <div *ngIf="form.get('city').touched && form.get('city').invalid" class="text-danger inaild_no">
                      <span *ngIf="form.get('city').errors.required">
                        City is required.
                      </span>

                      <span *ngIf="form.get('city').errors.minlength">
                        City name must be at least 2 characters.
                      </span>

                      <span *ngIf="form.get('city').errors.pattern">
                        Only alphabets are allowed.
                      </span>

                    </div>
                  </div>
                  
                  <div class="form-group col-4-div">
                    <label>Pincode <span class="text-danger" *ngIf="isIndiaSelected()">*</span></label>
                    <input formControlName="pin_code" class="form-control border-primary" type="text" placeholder=" " />
                    <div *ngIf="form.get('pin_code')?.touched && form.get('pin_code')?.invalid" class="text-danger inaild_no">

  <span *ngIf="form.get('pin_code')?.errors?.required">
    Pincode is required.
  </span>

  <span *ngIf="form.get('pin_code')?.errors?.pattern">
    Please enter a valid 6-digit pincode.
  </span>

</div>
                  </div>

                <ng-container *ngIf="visitorsControls.controls.length">
                        <h4 class="card-title mt-4">
                            <div class="d-flex bd-highlight">
                                <div class="p-2 flex-fill bd-highlight" style="font-size: 20px;">Add Persons details</div>
                            </div>
                        </h4>
                        
                        <ng-container formArrayName="visitors_basic_details" >
                          <div class="form-group col-12-div visitor_info" *ngFor="let visitor of visitorsControls.controls; let i=index">
                            <ng-container [formGroupName]="i">
                              <div class="form-group visitor_info_list">
                                <label>Full Name<span class="text-danger" >*</span></label>
                                <input [pattern]="'^[a-zA-Z \-\']+'" class="form-control border-primary" formControlName="full_name" name="full_name" required>
                                <div *ngIf="visitor.get('full_name').touched && visitor.get('full_name').invalid" class="text-danger inaild_no">
                                  <span *ngIf="visitor.get('full_name').errors.required">
                                    Name is required.
                                  </span>

                                  <span *ngIf="visitor.get('full_name').errors.minlength">
                                    Name must contain at least 2 characters.
                                  </span>

                                  <span *ngIf="visitor.get('full_name').errors.pattern">
                                    Only alphabets are allowed.
                                  </span>

                                </div>
                              </div>

                              <div class="form-group visitor_info_list">
                                <label>Age<span class="text-danger" >*</span></label>
                                <input class="form-control border-primary" type="number" formControlName="age" name="age" required>
                                <div *ngIf="visitor.get('age').touched && visitor.get('age').invalid" class="text-danger inaild_no">

                                    <span *ngIf="visitor.get('age').errors.required">
                                      Age is required.
                                    </span>

                                    <span *ngIf="visitor.get('age').errors.pattern">
                                      Age must be numeric.
                                    </span>

                                    <span *ngIf="visitor.get('age').errors.min || visitor.get('age').errors.max">
                                      Age must be between 1 and 120.
                                    </span>

                                  </div>
                              </div>

                              <div class="form-group visitor_info_list">
                                <label>Gender<span class="text-danger" >*</span></label>
                                <select class="form-control border-primary" name="gender" formControlName="gender">
                                  <option [value]="''">select</option>
                                  <option [value]="'Male'">Male</option>
                                  <option [value]="'Female'">Female</option>
                                  <option [value]="'Other'">Other</option>
                                </select>
                                <div *ngIf="visitor.get('gender').touched && visitor.get('gender').invalid" class="text-danger inaild_no">
                                  Please select gender.
                                </div>
                              </div>

                              <div class="form-group visitor_info_list">
                                <label>ID Proof Type<span class="text-danger" >*</span></label>
                                <select class="form-control border-primary" name="id_proof_type_id" formControlName="id_proof_type_id">
                                  <option [value]="''">select</option>
                                  <option [value]="type.id" *ngFor="let type of allIdProofTypes">{{type.name}}</option>
                                </select>
                                <div *ngIf="visitor.get('id_proof_type_id').touched && visitor.get('id_proof_type_id').invalid" class="text-danger inaild_no">
                                  Please select ID Proof Type.
                                </div>
                              </div>

                              <div class="form-group visitor_info_list">
                                <label>ID Proof Number<span class="text-danger" >*</span></label>
                                <input class="form-control border-primary" type="text" formControlName="id_proof_number" name="id_proof_number">
                                <div
        class="text-danger inaild_no"
        *ngIf="visitor.get('id_proof_number').touched &&
               visitor.get('id_proof_number').invalid">

        <span *ngIf="visitor.get('id_proof_number').errors.required">
            ID Proof Number is required.
        </span>

        <span
            *ngIf="visitor.get('id_proof_type_id').value == 1 &&
                   visitor.get('id_proof_number').errors.pattern">

            Aadhaar Number must be exactly 12 digits.
        </span>

        <span
            *ngIf="visitor.get('id_proof_type_id').value == 2 &&
                   visitor.get('id_proof_number').errors.pattern">

            Passport Number must be in format A1234567.
        </span>

    </div>
                              </div>

                              

                              <div class="form-group visitor_info_close" style="width: 4%;" *ngIf="i != 0">
                                <i class="fa fa-times remove-icon" aria-hidden="true" (click)="removeVisitor(i)"></i>
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>

                        <div class="form-group col-12-div" *ngIf="visitorsControls.controls.length">
                          <button type="button" class="btn btn-inverse-primary btn-fw" (click)="addVisitor()">
                            <i class="fa fa-plus"></i> Add Extra Bed
                          </button>
                        </div>
                </ng-container>





                <div class="button-wrap">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="saveData()" [disabled]="!form.valid">

                    Save
                </button>
                </div>

          </form>
        </div>
      </div>

      <div class="card-body" *ngIf = "showPay">
        <div style="width: 100%; float: left; padding-left: 20px;box-sizing: border-box;">
            <ul style="width: 100%; display: inline-block;list-style: none;padding: 0;margin: 0;">
            
            <li class="wrapper_label">
                <label>Booking No.</label>
                <small>{{bookingData?.booking_no}}</small>
            </li>
             <li class="wrapper_label">
                <label>Name</label>
                <small>{{bookingData?.full_name}}</small>
            </li>
            <li class="wrapper_label">
                <label>CheckIn Date</label>
                <small>{{bookingData?.from_date}}</small>
            </li>
            <li class="wrapper_label">
                <label>Checkout Date</label>
                <small>{{bookingData?.checkout_date}}</small>
            </li>
            <li class="wrapper_label">
                <label>Mobile Number</label>
                <small>{{bookingData?.mobile_no}}</small>
            </li>
            <li class="wrapper_label">
                <label>Base Amount</label>
                <small>₹{{bookingData?.base_amount}}</small>
            </li>
            <li class="wrapper_label" *ngIf = "bookingData?.extra_bed_amount && bookingData?.extra_bed_amount > 0">
                <label>Extra Bed Amount</label>
                <small>₹{{bookingData?.extra_bed_amount}}</small>
            </li>
            <li class="wrapper_label">
                <label>Total Amount</label>
                <small>₹{{bookingData?.total_charges}}</small>
            </li>
            <li class="wrapper_label">
                <label>Payment Status</label>
                <small>{{bookingData?.payment_status}}</small>
            </li>
            </ul>
            <ul style="width: 100%; display: inline-block;list-style: none;padding: 0;margin: 0;">
            <div class="form-group col-4-div wrapper_label" style="padding-right: 10px;box-sizing: border-box;width: 30%;">
                <label >Payment Mode*</label>
                <select class="form-control border-primary"  name="payment_type_id" [(ngModel)]="payment_type_id" required>
                <option [value]="''">select</option>
                <ng-container *ngFor="let data of allPaymentTypes">
                            <option [value]="data.id">{{data.type}}
                            </option>
                        </ng-container>
                </select>
            </div>

            <div *ngIf = "payment_type_id != 2 && payment_type_id != 3" class="form-group col-6-div wrapper_label" style="padding-right: 10px;box-sizing: border-box;width: 30%;">
                <label >Transaction No. / Receipt No.*</label>
                <input class="form-control border-primary" type="text" (ngModelChange)= "removeSpaces()"  [(ngModel)]="transaction_no" name="transaction_no" required>
                <div  class="inaild_no" *ngIf="transaction_validation_msg">{{transaction_validation_msg}}</div>
            </div>

            <div class="button-wrap">
                <button  type="submit" (click) = "savePayData()" *ngIf = "payment_type_id != 2 && payment_type_id != 3"  [disabled]="payment_type_id == '' || transaction_no == '' || transaction_validation_msg" class="btn btn-primary btn-fw" style="margin-right: 10px;">Print</button>
                <button  type="submit" (click) = "addPaymentDetail()" *ngIf = "payment_type_id == 2 || payment_type_id == 3"  [disabled]="payment_type_id == ''" class="btn btn-primary btn-fw" style="margin-right: 10px;">Next</button>
                <button  type="button" class="btn btn-secondary btn-fw" routerLink="/annadaan">Close</button>
            </div>
            </ul>
        </div>
      </div>
    </div>
  </div>
</div>